import React from 'react';
import PropTypes from 'prop-types';
import classes from './Title.module.scss';

const Title = ({ children }) => <h1 className={classes.title}>{children}</h1>;

Title.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Title;
